var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 12.6667V9.06675C26.6667 6.82654 26.6667 5.70643 26.2307 4.85079C25.8472 4.09814 25.2353 3.48622 24.4827 3.10272C23.627 2.66675 22.5069 2.66675 20.2667 2.66675H11.7334C9.49316 2.66675 8.37306 2.66675 7.51741 3.10272C6.76476 3.48622 6.15284 4.09814 5.76935 4.85079C5.33337 5.70643 5.33337 6.82654 5.33337 9.06675V22.9334C5.33337 25.1736 5.33337 26.2937 5.76935 27.1494C6.15284 27.902 6.76476 28.5139 7.51741 28.8974C8.37306 29.3334 9.49316 29.3334 11.7334 29.3334H18.6667M18.6667 14.6667H10.6667M13.3334 20.0001H10.6667M21.3334 9.33341H10.6667M22 20.0031C22.235 19.3352 22.6987 18.7721 23.309 18.4134C23.9194 18.0547 24.637 17.9236 25.3347 18.0432C26.0325 18.1629 26.6654 18.5257 27.1213 19.0673C27.5772 19.6089 27.8268 20.2944 27.8257 21.0023C27.8257 23.0008 24.8279 24.0001 24.8279 24.0001M24.8666 28.0001H24.8799",
    stroke: "#395BA9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileQuestion);
export default __webpack_public_path__ + "static/media/FileQuestion.e4d56c36fcbc470099db7e22fd85447a.svg";
export { ForwardRef as ReactComponent };